import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Modal, Card, Spinner, Alert } from 'react-bootstrap';
import Navbar from './Navbar';
import FirmasPad from './FirmasPad';
import { toast } from 'react-toastify';
import '../styles/DescargoForm.css'

const API_URL = process.env.REACT_APP_API_URL || "/";

const DescargoForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [texto, setTexto] = useState('');
  const [firmaBase64, setFirmaBase64] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [informe, setInforme] = useState(null);
  const [loading, setLoading] = useState(true);
  const storedUser = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchInforme = async () => {
      try {
        const res = await fetch(`${API_URL}/api/informes/${id}`);
        const data = await res.json();
        if (!data.success) throw new Error('Informe no encontrado');
        setInforme(data.data);
      } catch (err) {
        toast.error('No se pudo cargar el informe');
      } finally {
        setLoading(false);
      }
    };

    fetchInforme();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!texto.trim()) {
      toast.error('El descargo no puede estar vacío');
      return;
    }

    if (!firmaBase64) {
      toast.error('Debes firmar antes de enviar');
      return;
    }

    try {
      const payload = { texto, firmaBase64 };

      const descargoRes = await fetch(`${API_URL}/api/informes/descargo/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!descargoRes.ok) throw new Error('Error al guardar descargo');

      const estadoRes = await fetch(`${API_URL}/api/informes/estado/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nuevoEstado: 'respondido',
          usuarioId: storedUser?.id
        })
      });

      if (!estadoRes.ok) throw new Error('Error al actualizar estado');

      toast.success('Descargo enviado correctamente');
      navigate('/home');
    } catch (error) {
      console.error('❌ Error al enviar descargo:', error);
      toast.error('No se pudo guardar el descargo');
    }
  };

  const handleGuardarFirma = (dataUrl, base64) => {
    setFirmaBase64(`data:image/png;base64,${base64}`);
    toast.success('Firma guardada correctamente');
    setShowModal(false);
  };

  const handleCancelarFirma = () => {
    setShowModal(false);
    toast.info('Firma cancelada');
  };

  if (loading) {
    return (
      <Container className="py-4 text-center">
        <Navbar />
        <Spinner animation="border" />
        <p>Cargando informe...</p>
      </Container>
    );
  }

  if (!informe) {
    return (
      <Container className="py-4 text-center">
        <Navbar />
        <Alert variant="danger">No se encontró el informe</Alert>
      </Container>
    );
  }

  return (
    <Container className="descargo-container">
    <Navbar />
    <h3>Responder Informe</h3>

    <div className="motivo-card">
      <h5>Motivo: {informe.motivo}</h5>
      <p>{informe.motivo_detalle || 'Sin mensaje registrado'}</p>
      <p className="text-muted">
        Fecha del informe: {new Date(informe.fecha).toLocaleDateString('es-AR')}
      </p>
    </div>

    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="descargoTexto">
        <Form.Label>Escribí tu descargo</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mt-4">
        <Form.Label>Firma digital</Form.Label>
        <div className="firma-actions">
          <Button variant="info" onClick={() => setShowModal(true)}>
            Firmar
          </Button>
          {firmaBase64 && (
            <img src={firmaBase64} alt="Firma" className="firma-preview" />
          )}
        </div>
      </Form.Group>

      <Button variant="primary" type="submit">
        Enviar Descargo
      </Button>
    </Form>
    <Modal show={showModal} onHide={handleCancelarFirma} centered>
      <Modal.Header closeButton>
        <Modal.Title>Firmar Descargo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FirmasPad
          onFirmar={handleGuardarFirma}
          onCancelar={handleCancelarFirma}
        />
      </Modal.Body>
    </Modal>
  </Container>

  );
};

export default DescargoForm;
